import { hotamClient } from '@app/config/repository';
import { type PingResponse, getPing as requestPing } from '@hotam/repository/ping';

export type { PingResponse };

export const getPing = (signal?: AbortSignal) => requestPing(hotamClient, signal);
